var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsortedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5649",
    "data-name": "Group 5649",
    transform: "translate(-266 -145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swap",
    transform: "translate(365.625 145.997) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5643",
    "data-name": "Group 5643",
    transform: "translate(0.002 85.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5642",
    "data-name": "Group 5642",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4639",
    "data-name": "Path 4639",
    d: "M2.412,89.568h8.176a.706.706,0,1,0,0-1.411H2.412L4.03,86.538a.706.706,0,1,0-1-1L.209,88.363c-.016.016-.032.034-.047.052l-.019.025-.022.03c-.007.01-.013.02-.019.031l-.017.028c-.006.01-.01.021-.015.032s-.01.02-.014.031-.008.021-.012.032-.008.022-.012.034-.006.021-.008.032-.006.023-.009.035,0,.025-.006.037,0,.02,0,.031a.71.71,0,0,0,0,.139c0,.01,0,.021,0,.031s0,.025.006.037.006.023.009.035.005.021.008.032.008.022.012.034.007.021.012.032.009.02.014.031.01.022.015.032l.017.028c.006.01.012.021.019.031l.022.03.019.025q.022.027.046.051h0l2.823,2.823a.706.706,0,1,0,1-1Z",
    transform: "translate(-0.002 -85.334)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4640",
    "data-name": "Path 4640",
    d: "M181.8,217.312l.019-.025.022-.03c.007-.01.013-.021.019-.031l.017-.028c.006-.01.01-.021.016-.032s.01-.02.014-.03.008-.021.012-.032.008-.022.012-.034.006-.021.008-.032.006-.023.009-.035,0-.025.006-.037,0-.02,0-.031a.708.708,0,0,0,0-.139c0-.01,0-.021,0-.031s0-.025-.006-.037-.006-.023-.009-.035-.005-.021-.008-.032-.008-.022-.012-.034-.007-.021-.012-.032-.009-.02-.014-.03-.01-.022-.016-.032l-.017-.028c-.006-.01-.012-.021-.019-.031l-.022-.03-.019-.025q-.022-.027-.046-.051h0l-2.823-2.823a.706.706,0,0,0-1,1l1.618,1.618h-8.176a.706.706,0,0,0,0,1.411h8.176l-1.618,1.618a.706.706,0,0,0,1,1l2.823-2.823h0Q181.776,217.339,181.8,217.312Z",
    transform: "translate(-165.022 -209.102)",
    fill: "#4f5b6d"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15093",
    "data-name": "Rectangle 15093",
    width: 18,
    height: 18,
    transform: "translate(266 145)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsortedIcon);
export default __webpack_public_path__ + "static/media/unsorted-icon.9dc655d7ac547ed4f9bb74d70540cfea.svg";
export { ForwardRef as ReactComponent };